var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProduction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_production_a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v821H0V0h1440Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_production_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0Zm0 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 3a1 1 0 0 1 1 1v4h4a1 1 0 0 1 0 2h-5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_production_a)",
    transform: "translate(-709 -765)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_production_b)",
    transform: "translate(709 765)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CFB170",
    d: "M0 0h22v22H0V0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProduction);
export default __webpack_public_path__ + "static/media/iconProduction.f89472e25f80a8848eb79d7aeffd5dfe.svg";
export { ForwardRef as ReactComponent };